import { connect } from 'react-redux';
import InvoiceEditorSlidingPanel from './InvoiceEditorSlidingPanel';
import { fetchInvoiceById } from 'redux/invoices/InvoicesActions';
import { bindActionCreators } from "redux";

const mapStateToProps = ({ invoices }) => ({
  invoiceData: invoices.invoice
});

const mapDispatchToProps = dispatch => ({
  invoicesActions: bindActionCreators({ fetchInvoiceById }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceEditorSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/InvoiceEditorSlidingPanelConnector.js